var items = {
  "block.minecraft.air": "luaft",
  "block.minecraft.stone": "stoa",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "polierta granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "polierta diorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "polierta andesit",
  "block.minecraft.grass_block": "grasblock",
  "block.minecraft.dirt": "eadn",
  "block.minecraft.coarse_dirt": "gorbe eadn",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "karmesin-nezel",
  "block.minecraft.warped_nylium": "wirr-nezel",
  "block.minecraft.cobblestone": "bruchstoa",
  "block.minecraft.oak_planks": "oachenhoizbretta",
  "block.minecraft.spruce_planks": "fitchnhoizbretta",
  "block.minecraft.birch_planks": "birknhoizbretta",
  "block.minecraft.jungle_planks": "tropnhoizbretta",
  "block.minecraft.acacia_planks": "akazienhoizbretta",
  "block.minecraft.dark_oak_planks": "schwoazoachenbretta",
  "block.minecraft.crimson_planks": "karmesinbretta",
  "block.minecraft.warped_planks": "wirrbretta",
  "block.minecraft.oak_sapling": "oachenzweigerl",
  "block.minecraft.spruce_sapling": "fichtnzweigerl",
  "block.minecraft.birch_sapling": "birknzweigerl",
  "block.minecraft.jungle_sapling": "tropnbaamzweigerl",
  "block.minecraft.acacia_sapling": "akazienzweigerl",
  "block.minecraft.dark_oak_sapling": "schwoazoachenzweigerl",
  "block.minecraft.bedrock": "grundstoa",
  "block.minecraft.sand": "sond",
  "block.minecraft.red_sand": "rouda sond",
  "block.minecraft.gravel": "kies",
  "block.minecraft.gold_ore": "goiderz",
  "block.minecraft.iron_ore": "eisenerz",
  "block.minecraft.coal_ore": "kuinerz",
  "block.minecraft.nether_gold_ore": "nethergoiderz",
  "block.minecraft.oak_log": "oachenstamm",
  "block.minecraft.spruce_log": "fichtnstamm",
  "block.minecraft.birch_log": "birkenhoiz",
  "block.minecraft.jungle_log": "tropnbaamstamm",
  "block.minecraft.acacia_log": "akazienstamm",
  "block.minecraft.dark_oak_log": "schwoazoachenstamm",
  "block.minecraft.crimson_stem": "karmesinstamm",
  "block.minecraft.warped_stem": "wirrstil",
  "block.minecraft.stripped_oak_log": "entrindeter oachenstamm",
  "block.minecraft.stripped_spruce_log": "entrindeter fichtnstamm",
  "block.minecraft.stripped_birch_log": "entrindeter birknstamm",
  "block.minecraft.stripped_jungle_log": "entrindeter tropnbaamstamm",
  "block.minecraft.stripped_acacia_log": "entrindeter akazienstamm",
  "block.minecraft.stripped_dark_oak_log": "entrindeter schwoazoachenstamm",
  "block.minecraft.stripped_crimson_stem": "geschälta karmesinstil",
  "block.minecraft.stripped_warped_stem": "geschälta wirrstil",
  "block.minecraft.stripped_oak_wood": "entrindetes oachenhoiz",
  "block.minecraft.stripped_spruce_wood": "entrindetes fichtnhoiz",
  "block.minecraft.stripped_birch_wood": "entrindetes birknhoiz",
  "block.minecraft.stripped_jungle_wood": "entrindetes tropnhoiz",
  "block.minecraft.stripped_acacia_wood": "entrindetes akazienhoiz",
  "block.minecraft.stripped_dark_oak_wood": "entrindetes schwoazoachenhoiz",
  "block.minecraft.stripped_crimson_hyphae": "geschälta karmesinhyphn",
  "block.minecraft.stripped_warped_hyphae": "geschälta wirrhyphn",
  "block.minecraft.oak_wood": "oachenhoiz",
  "block.minecraft.spruce_wood": "fichtnhoiz",
  "block.minecraft.birch_wood": "birknhoiz",
  "block.minecraft.jungle_wood": "tropnhoiz",
  "block.minecraft.acacia_wood": "akazienhoiz",
  "block.minecraft.dark_oak_wood": "schwoazoachenhoiz",
  "block.minecraft.crimson_hyphae": "karmesinhyphn",
  "block.minecraft.warped_hyphae": "wirrhyphn",
  "block.minecraft.oak_leaves": "oachenlaub",
  "block.minecraft.spruce_leaves": "fichtnnadeln",
  "block.minecraft.birch_leaves": "birknlaub",
  "block.minecraft.jungle_leaves": "tropnbaamlaub",
  "block.minecraft.acacia_leaves": "akazienlaub",
  "block.minecraft.dark_oak_leaves": "schwoazoachenlaub",
  "block.minecraft.sponge": "schwomm",
  "block.minecraft.wet_sponge": "nossa schwomm",
  "block.minecraft.glass": "glos",
  "block.minecraft.lapis_ore": "lapislazulierz",
  "block.minecraft.lapis_block": "lapislazuliblock",
  "block.minecraft.dispenser": "werfa",
  "block.minecraft.sandstone": "sondstoa",
  "block.minecraft.chiseled_sandstone": "gemeißelta sondstoa",
  "block.minecraft.cut_sandstone": "g'schnittener sondstoa",
  "block.minecraft.note_block": "notnblock",
  "block.minecraft.powered_rail": "antriebsschiene",
  "block.minecraft.detector_rail": "sensorschiene",
  "block.minecraft.sticky_piston": "klebriga kolbn",
  "block.minecraft.cobweb": "spinnfeggeln",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "farn",
  "block.minecraft.dead_bush": "douda busch",
  "block.minecraft.seagrass": "seegras",
  "block.minecraft.sea_pickle": "meeresgugumma",
  "block.minecraft.piston": "kolbn",
  "block.minecraft.white_wool": "weiße wolle",
  "block.minecraft.orange_wool": "orange wolle",
  "block.minecraft.magenta_wool": "magenta wolle",
  "block.minecraft.light_blue_wool": "höiblaue wolle",
  "block.minecraft.yellow_wool": "gejbe wolle",
  "block.minecraft.lime_wool": "giftgreane wolle",
  "block.minecraft.pink_wool": "rosa wolle",
  "block.minecraft.gray_wool": "graue wolle",
  "block.minecraft.light_gray_wool": "höigraue wolle",
  "block.minecraft.cyan_wool": "türkise wolle",
  "block.minecraft.purple_wool": "violette wolle",
  "block.minecraft.blue_wool": "blaue wolle",
  "block.minecraft.brown_wool": "braune wolle",
  "block.minecraft.green_wool": "greane wolle",
  "block.minecraft.red_wool": "roude wolle",
  "block.minecraft.black_wool": "schwoaze wolle",
  "block.minecraft.dandelion": "löwnzahn",
  "block.minecraft.poppy": "mohn",
  "block.minecraft.blue_orchid": "blaue oachidee",
  "block.minecraft.allium": "steanlauch",
  "block.minecraft.azure_bluet": "porzellansteanchn",
  "block.minecraft.red_tulip": "roude tulpe",
  "block.minecraft.orange_tulip": "orange tulpe",
  "block.minecraft.white_tulip": "weiße tulpe",
  "block.minecraft.pink_tulip": "rosa tulpe",
  "block.minecraft.oxeye_daisy": "margerite",
  "block.minecraft.cornflower": "koanbleame",
  "block.minecraft.lily_of_the_valley": "maigleggal",
  "block.minecraft.wither_rose": "witherrosn",
  "block.minecraft.brown_mushroom": "brauna schwammal",
  "block.minecraft.red_mushroom": "rouda schwammal",
  "block.minecraft.crimson_fungus": "karmesinschwammal",
  "block.minecraft.warped_fungus": "wirrschwammal",
  "block.minecraft.crimson_roots": "karmesinwuazn",
  "block.minecraft.warped_roots": "wirrwuazn",
  "block.minecraft.nether_sprouts": "nethersprosse",
  "block.minecraft.weeping_vines": "trauarankn",
  "block.minecraft.twisting_vines": "zwirbelrankn",
  "block.minecraft.sugar_cane": "zuggarohr",
  "block.minecraft.kelp": "seetang",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "goidblock",
  "block.minecraft.iron_block": "eisenblock",
  "block.minecraft.oak_slab": "oachenstufe",
  "block.minecraft.spruce_slab": "fichtnhoizstufe",
  "block.minecraft.birch_slab": "birknhoizstufe",
  "block.minecraft.jungle_slab": "tropnhoizstufe",
  "block.minecraft.acacia_slab": "akazienhoizstufe",
  "block.minecraft.dark_oak_slab": "schwoazoachenhoizstufe",
  "block.minecraft.crimson_slab": "karmesinstufe",
  "block.minecraft.warped_slab": "wirrstufe",
  "block.minecraft.stone_slab": "stoastufe",
  "block.minecraft.smooth_stone_slab": "glatte stoastufe",
  "block.minecraft.sandstone_slab": "sandstoastufe",
  "block.minecraft.cut_sandstone_slab": "g'schnittene sondstoastufe",
  "block.minecraft.petrified_oak_slab": "verstoanate oachenhoizstufe",
  "block.minecraft.cobblestone_slab": "bruchstoastufe",
  "block.minecraft.brick_slab": "ziegelstufe",
  "block.minecraft.stone_brick_slab": "stoaziegelstufe",
  "block.minecraft.nether_brick_slab": "netherzieglstufe",
  "block.minecraft.quartz_slab": "quarzstufe",
  "block.minecraft.red_sandstone_slab": "rote sandstoastufe",
  "block.minecraft.cut_red_sandstone_slab": "g'schnittene roude sondstoastufe",
  "block.minecraft.purpur_slab": "purpurstufe",
  "block.minecraft.prismarine_slab": "prismarinstufe",
  "block.minecraft.prismarine_brick_slab": "prismarinzieglstufe",
  "block.minecraft.dark_prismarine_slab": "dunkle prismarinstufe",
  "block.minecraft.smooth_quartz": "glatte quarzblock",
  "block.minecraft.smooth_red_sandstone": "glatte rouder sondstoa",
  "block.minecraft.smooth_sandstone": "glatte sondstoa",
  "block.minecraft.smooth_stone": "glatte stoa",
  "block.minecraft.bricks": "zieglstoane",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "buacharegal",
  "block.minecraft.mossy_cobblestone": "bemooster bruchstoa",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "fackel",
  "block.minecraft.end_rod": "endstob",
  "block.minecraft.chorus_plant": "choruspflanzna",
  "block.minecraft.chorus_flower": "chorusbliate",
  "block.minecraft.purpur_block": "purpurblock",
  "block.minecraft.purpur_pillar": "purpursäule",
  "block.minecraft.purpur_stairs": "purpurschdiang",
  "block.minecraft.spawner": "spawna",
  "block.minecraft.oak_stairs": "oachenhoizschdiang",
  "block.minecraft.chest": "truhe",
  "block.minecraft.diamond_ore": "diamanterz",
  "block.minecraft.diamond_block": "diamantblock",
  "block.minecraft.crafting_table": "werkbank",
  "block.minecraft.farmland": "ackabodn",
  "block.minecraft.furnace": "ofn",
  "block.minecraft.ladder": "leita",
  "block.minecraft.rail": "schiene",
  "block.minecraft.cobblestone_stairs": "bruchstoaschdiang",
  "block.minecraft.lever": "hebl",
  "block.minecraft.stone_pressure_plate": "stoadruckplatte",
  "block.minecraft.oak_pressure_plate": "oachenhoizdruckplatte",
  "block.minecraft.spruce_pressure_plate": "fichtnhoizdruckplatte",
  "block.minecraft.birch_pressure_plate": "birknhoizdruckplatte",
  "block.minecraft.jungle_pressure_plate": "tropnhoizdruckplatte",
  "block.minecraft.acacia_pressure_plate": "akazienhoizdruckplatte",
  "block.minecraft.dark_oak_pressure_plate": "schwoazoachenhoizdruckplatte",
  "block.minecraft.crimson_pressure_plate": "karmesindruckplatte",
  "block.minecraft.warped_pressure_plate": "wirrdruckplatte",
  "block.minecraft.polished_blackstone_pressure_plate": "polierte schwoazstoadruckplatte",
  "block.minecraft.redstone_ore": "redstone-erz",
  "block.minecraft.redstone_torch": "redstone-fackel",
  "block.minecraft.snow": "schnää",
  "block.minecraft.ice": "eis",
  "block.minecraft.snow_block": "schnääblock",
  "block.minecraft.cactus": "kaktää",
  "block.minecraft.clay": "ton",
  "block.minecraft.jukebox": "plattnspiela",
  "block.minecraft.oak_fence": "oachnhoizzaun",
  "block.minecraft.spruce_fence": "fichtnhoizzaun",
  "block.minecraft.birch_fence": "birknhoizzaun",
  "block.minecraft.jungle_fence": "tropnhoizzaun",
  "block.minecraft.acacia_fence": "akazienhoizzaun",
  "block.minecraft.dark_oak_fence": "schwoazoachnhoizzaun",
  "block.minecraft.crimson_fence": "karmesinzaun",
  "block.minecraft.warped_fence": "wirrzaun",
  "block.minecraft.pumpkin": "kürbis",
  "block.minecraft.carved_pumpkin": "g'schnitzta kürbis",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "seelensond",
  "block.minecraft.soul_soil": "seelenerdn",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polierta basalt",
  "block.minecraft.soul_torch": "seelenfackel",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "kürbislaterne",
  "block.minecraft.oak_trapdoor": "oachenhoizklappdierl",
  "block.minecraft.spruce_trapdoor": "fichtnhoizklappdierl",
  "block.minecraft.birch_trapdoor": "birknhoizklappdierl",
  "block.minecraft.jungle_trapdoor": "tropnhoizklappdierl",
  "block.minecraft.acacia_trapdoor": "akazienhoizklappdierl",
  "block.minecraft.dark_oak_trapdoor": "schwoazoachenhoizklappdierl",
  "block.minecraft.crimson_trapdoor": "karmesinklappdierl",
  "block.minecraft.warped_trapdoor": "wirrklappdierl",
  "block.minecraft.infested_stone": "b’foiner stoa",
  "block.minecraft.infested_cobblestone": "b’foina bruchstoa",
  "block.minecraft.infested_stone_bricks": "b’foine stoazigl",
  "block.minecraft.infested_mossy_stone_bricks": "b’foine vamooste stoazigl",
  "block.minecraft.infested_cracked_stone_bricks": "b’foine g’sprungane stoazigl",
  "block.minecraft.infested_chiseled_stone_bricks": "b’foine g’meißlte stoazigl",
  "block.minecraft.stone_bricks": "stoazigl",
  "block.minecraft.mossy_stone_bricks": "vamoosta stoazigl",
  "block.minecraft.cracked_stone_bricks": "g’sprungane stoazigl",
  "block.minecraft.chiseled_stone_bricks": "g’meißlte stoazigl",
  "block.minecraft.brown_mushroom_block": "brauna schwammalblock",
  "block.minecraft.red_mushroom_block": "rouda schwammalblock",
  "block.minecraft.mushroom_stem": "schwammalstil",
  "block.minecraft.iron_bars": "eisengitta",
  "block.minecraft.chain": "verkettn",
  "block.minecraft.glass_pane": "glasscheibe",
  "block.minecraft.melon": "melone",
  "block.minecraft.vine": "rankn",
  "block.minecraft.oak_fence_gate": "oachnhoizzauntor",
  "block.minecraft.spruce_fence_gate": "fichtnhoizzauntor",
  "block.minecraft.birch_fence_gate": "birknhoizzauntor",
  "block.minecraft.jungle_fence_gate": "tropnhoizzauntor",
  "block.minecraft.acacia_fence_gate": "akazienhoizzauntor",
  "block.minecraft.dark_oak_fence_gate": "schwoazoachnhoizzauntor",
  "block.minecraft.crimson_fence_gate": "karmesinzauntor",
  "block.minecraft.warped_fence_gate": "wirrzauntor",
  "block.minecraft.brick_stairs": "zieglschdiang",
  "block.minecraft.stone_brick_stairs": "stoazieglschdiang",
  "block.minecraft.mycelium": "myzel",
  "block.minecraft.lily_pad": "seerosnbladdl",
  "block.minecraft.nether_bricks": "netherziegl",
  "block.minecraft.cracked_nether_bricks": "rissige netherziegl",
  "block.minecraft.chiseled_nether_bricks": "gemeißelte netherziegl",
  "block.minecraft.nether_brick_fence": "netherzieglzaun",
  "block.minecraft.nether_brick_stairs": "netherzieglschdiang",
  "block.minecraft.enchanting_table": "zaubadisch",
  "block.minecraft.end_portal_frame": "endportalrahmen",
  "block.minecraft.end_stone": "endstoa",
  "block.minecraft.end_stone_bricks": "endstoaziegl",
  "block.minecraft.dragon_egg": "drachnoa",
  "block.minecraft.redstone_lamp": "redstone-lampe",
  "block.minecraft.sandstone_stairs": "sondstoaschdiang",
  "block.minecraft.emerald_ore": "smaragderz",
  "block.minecraft.ender_chest": "endertruhe",
  "block.minecraft.tripwire_hook": "hakn",
  "block.minecraft.emerald_block": "smaragdblock",
  "block.minecraft.spruce_stairs": "fichtnhoizschdiang",
  "block.minecraft.birch_stairs": "birkenhoizschdiang",
  "block.minecraft.jungle_stairs": "tropnhoizschdiang",
  "block.minecraft.crimson_stairs": "karmesinschdiang",
  "block.minecraft.warped_stairs": "wirrschdiang",
  "block.minecraft.command_block": "befehlsblock",
  "block.minecraft.beacon": "leichtfeia",
  "block.minecraft.cobblestone_wall": "bruchstoamaua",
  "block.minecraft.mossy_cobblestone_wall": "bemooste bruchstoamaua",
  "block.minecraft.brick_wall": "zieglstoimaua",
  "block.minecraft.prismarine_wall": "prismarinmaua",
  "block.minecraft.red_sandstone_wall": "roude sondstoamaua",
  "block.minecraft.mossy_stone_brick_wall": "bemooste stoizieglmaua",
  "block.minecraft.granite_wall": "grantimaua",
  "block.minecraft.stone_brick_wall": "stoazieglmaua",
  "block.minecraft.nether_brick_wall": "netherzieglmaua",
  "block.minecraft.andesite_wall": "andesitmaua",
  "block.minecraft.red_nether_brick_wall": "rode netherzieglmaua",
  "block.minecraft.sandstone_wall": "sondstoamaua",
  "block.minecraft.end_stone_brick_wall": "endstoizieglmaua",
  "block.minecraft.diorite_wall": "dioritmaua",
  "block.minecraft.blackstone_wall": "schwoazstoamaua",
  "block.minecraft.polished_blackstone_wall": "polierte schwoazstoamaua",
  "block.minecraft.polished_blackstone_brick_wall": "polierte schwoazstoazieglmaua",
  "block.minecraft.stone_button": "stoaknopf",
  "block.minecraft.oak_button": "oachenhoizknopf",
  "block.minecraft.spruce_button": "fichtnhoizknopf",
  "block.minecraft.birch_button": "birknhoizknopf",
  "block.minecraft.jungle_button": "tropnhoizknopf",
  "block.minecraft.acacia_button": "akazienhoizknopf",
  "block.minecraft.dark_oak_button": "schwoazoachenhoizknopf",
  "block.minecraft.crimson_button": "karmesinknopf",
  "block.minecraft.warped_button": "wirrknopf",
  "block.minecraft.polished_blackstone_button": "polierta schwoazstoaknopf",
  "block.minecraft.anvil": "amboss",
  "block.minecraft.chipped_anvil": "oang'schlog'na amboss",
  "block.minecraft.damaged_anvil": "beschädigta amboss",
  "block.minecraft.trapped_chest": "redstone-truhe",
  "block.minecraft.light_weighted_pressure_plate": "feinwägeplatte",
  "block.minecraft.heavy_weighted_pressure_plate": "grobwägeplatte",
  "block.minecraft.daylight_detector": "dogesliachtsensor",
  "block.minecraft.redstone_block": "redstone-block",
  "block.minecraft.nether_quartz_ore": "netherquarzerz",
  "block.minecraft.hopper": "trichta",
  "block.minecraft.chiseled_quartz_block": "gemeißelta quarzblock",
  "block.minecraft.quartz_block": "quarzblock",
  "block.minecraft.quartz_bricks": "quarzziegl",
  "block.minecraft.quartz_pillar": "quarzsäule",
  "block.minecraft.quartz_stairs": "quarzschdiang",
  "block.minecraft.activator_rail": "aktivierungsschiene",
  "block.minecraft.dropper": "spenda",
  "block.minecraft.white_terracotta": "weiße keramik",
  "block.minecraft.orange_terracotta": "oranges keramik",
  "block.minecraft.magenta_terracotta": "magenta keramik",
  "block.minecraft.light_blue_terracotta": "höiblaues keramik",
  "block.minecraft.yellow_terracotta": "gejbs keramik",
  "block.minecraft.lime_terracotta": "giftgreans keramik",
  "block.minecraft.pink_terracotta": "rosa keramik",
  "block.minecraft.gray_terracotta": "graus keramik",
  "block.minecraft.light_gray_terracotta": "höigraues keramik",
  "block.minecraft.cyan_terracotta": "türkis' keramik",
  "block.minecraft.purple_terracotta": "violetts keramik",
  "block.minecraft.blue_terracotta": "blaus keramik",
  "block.minecraft.brown_terracotta": "brauns keramik",
  "block.minecraft.green_terracotta": "greans keramik",
  "block.minecraft.red_terracotta": "rouds keramik",
  "block.minecraft.black_terracotta": "schwoazs keramik",
  "block.minecraft.barrier": "barriere",
  "block.minecraft.iron_trapdoor": "eisenklappdierl",
  "block.minecraft.hay_block": "strohboin",
  "block.minecraft.white_carpet": "weißa teppich",
  "block.minecraft.orange_carpet": "oranga teppich",
  "block.minecraft.magenta_carpet": "magenta teppich",
  "block.minecraft.light_blue_carpet": "höiblaua teppich",
  "block.minecraft.yellow_carpet": "gejba teppich",
  "block.minecraft.lime_carpet": "giftgreana teppich",
  "block.minecraft.pink_carpet": "rosa teppich",
  "block.minecraft.gray_carpet": "graua teppich",
  "block.minecraft.light_gray_carpet": "höigraua teppich",
  "block.minecraft.cyan_carpet": "türkisa teppich",
  "block.minecraft.purple_carpet": "violetta teppich",
  "block.minecraft.blue_carpet": "blaua teppich",
  "block.minecraft.brown_carpet": "brauna teppich",
  "block.minecraft.green_carpet": "greana teppich",
  "block.minecraft.red_carpet": "rouda teppich",
  "block.minecraft.black_carpet": "schwoaza teppich",
  "block.minecraft.terracotta": "keramik",
  "block.minecraft.coal_block": "kuinblock",
  "block.minecraft.packed_ice": "packeis",
  "block.minecraft.acacia_stairs": "akazienhoizschdiang",
  "block.minecraft.dark_oak_stairs": "schwoazoachenhoizschdiang",
  "block.minecraft.slime_block": "schleimblock",
  "block.minecraft.grass_path": "tramplpfad",
  "block.minecraft.sunflower": "sunnableame",
  "block.minecraft.lilac": "flieda",
  "block.minecraft.rose_bush": "rosnstrauch",
  "block.minecraft.peony": "pfingstrose",
  "block.minecraft.tall_grass": "hohes gras",
  "block.minecraft.large_fern": "großer farn",
  "block.minecraft.white_stained_glass": "weißes glas",
  "block.minecraft.orange_stained_glass": "oranges glas",
  "block.minecraft.magenta_stained_glass": "magenta glas",
  "block.minecraft.light_blue_stained_glass": "höiblaues glas",
  "block.minecraft.yellow_stained_glass": "gejbs glas",
  "block.minecraft.lime_stained_glass": "giftgreans glas",
  "block.minecraft.pink_stained_glass": "rosa glas",
  "block.minecraft.gray_stained_glass": "graus glas",
  "block.minecraft.light_gray_stained_glass": "höigraues glas",
  "block.minecraft.cyan_stained_glass": "türkis' glas",
  "block.minecraft.purple_stained_glass": "violetts glas",
  "block.minecraft.blue_stained_glass": "blaus glas",
  "block.minecraft.brown_stained_glass": "brauns glas",
  "block.minecraft.green_stained_glass": "greans glas",
  "block.minecraft.red_stained_glass": "rouds glas",
  "block.minecraft.black_stained_glass": "schwoazs glas",
  "block.minecraft.white_stained_glass_pane": "weiße glasscheibe",
  "block.minecraft.orange_stained_glass_pane": "orange glasscheibe",
  "block.minecraft.magenta_stained_glass_pane": "magenta glasscheibe",
  "block.minecraft.light_blue_stained_glass_pane": "höiblaue glasscheibe",
  "block.minecraft.yellow_stained_glass_pane": "gejbe glasscheibe",
  "block.minecraft.lime_stained_glass_pane": "giftgreane glasscheibe",
  "block.minecraft.pink_stained_glass_pane": "rosa glasscheibe",
  "block.minecraft.gray_stained_glass_pane": "graue glasscheibe",
  "block.minecraft.light_gray_stained_glass_pane": "höigraue glasscheibe",
  "block.minecraft.cyan_stained_glass_pane": "türkise glasscheibe",
  "block.minecraft.purple_stained_glass_pane": "violette glasscheibe",
  "block.minecraft.blue_stained_glass_pane": "blaue glasscheibe",
  "block.minecraft.brown_stained_glass_pane": "braune glasscheibe",
  "block.minecraft.green_stained_glass_pane": "greane glasscheibe",
  "block.minecraft.red_stained_glass_pane": "roude glasscheibe",
  "block.minecraft.black_stained_glass_pane": "schwoaze glasscheibe",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "prismarinziegl",
  "block.minecraft.dark_prismarine": "dunkla prismarin",
  "block.minecraft.prismarine_stairs": "prismarinschdiang",
  "block.minecraft.prismarine_brick_stairs": "prismarinzieglschdiang",
  "block.minecraft.dark_prismarine_stairs": "dunkle prismarinschdiang",
  "block.minecraft.sea_lantern": "seelaterne",
  "block.minecraft.red_sandstone": "rouda sondstoa",
  "block.minecraft.chiseled_red_sandstone": "gemeißelta rouder sondstoa",
  "block.minecraft.cut_red_sandstone": "g'schnittener rouder sondstoa",
  "block.minecraft.red_sandstone_stairs": "roude sondstoaschdiang",
  "block.minecraft.repeating_command_block": "wiedahol-befehlsblock",
  "block.minecraft.chain_command_block": "kettn-befehlsblock",
  "block.minecraft.magma_block": "magmablock",
  "block.minecraft.nether_wart_block": "netherwarznblock",
  "block.minecraft.warped_wart_block": "wirrwarznblock",
  "block.minecraft.red_nether_bricks": "roude netherziegl",
  "block.minecraft.bone_block": "boanenblock",
  "block.minecraft.structure_void": "konstruktionsleere",
  "block.minecraft.observer": "beobachta",
  "block.minecraft.shulker_box": "shulker-kiste",
  "block.minecraft.white_shulker_box": "weiße shulker-kiste",
  "block.minecraft.orange_shulker_box": "orange shulker-kiste",
  "block.minecraft.magenta_shulker_box": "magenta shulker-kiste",
  "block.minecraft.light_blue_shulker_box": "höiblaue shulker-kiste",
  "block.minecraft.yellow_shulker_box": "gejbe shulker-kiste",
  "block.minecraft.lime_shulker_box": "giftgreane shulker-kiste",
  "block.minecraft.pink_shulker_box": "rosa shulker-kiste",
  "block.minecraft.gray_shulker_box": "graue shulker-kiste",
  "block.minecraft.light_gray_shulker_box": "höigraue shulker-kiste",
  "block.minecraft.cyan_shulker_box": "türkise shulker-kiste",
  "block.minecraft.purple_shulker_box": "violette shulker-kiste",
  "block.minecraft.blue_shulker_box": "blaue shulker-kiste",
  "block.minecraft.brown_shulker_box": "braune shulker-kiste",
  "block.minecraft.green_shulker_box": "greane shulker-kiste",
  "block.minecraft.red_shulker_box": "roude shulker-kiste",
  "block.minecraft.black_shulker_box": "schwoaze shulker-kiste",
  "block.minecraft.white_glazed_terracotta": "weiße glasierde keramik",
  "block.minecraft.orange_glazed_terracotta": "orange glasierte keramik",
  "block.minecraft.magenta_glazed_terracotta": "magenta glasierte keramik",
  "block.minecraft.light_blue_glazed_terracotta": "höiblaue glasierte keramik",
  "block.minecraft.yellow_glazed_terracotta": "gejbe glasierte keramik",
  "block.minecraft.lime_glazed_terracotta": "giftgreane glasierte keramik",
  "block.minecraft.pink_glazed_terracotta": "rosa glasierte keramik",
  "block.minecraft.gray_glazed_terracotta": "graue glasierte keramik",
  "block.minecraft.light_gray_glazed_terracotta": "höigraue glasierte keramik",
  "block.minecraft.cyan_glazed_terracotta": "türkise glasierte keramik",
  "block.minecraft.purple_glazed_terracotta": "violette glasierte keramik",
  "block.minecraft.blue_glazed_terracotta": "blaue glasierte keramik",
  "block.minecraft.brown_glazed_terracotta": "braune glasierte keramik",
  "block.minecraft.green_glazed_terracotta": "greane glasierte keramik",
  "block.minecraft.red_glazed_terracotta": "roude glasierte keramik",
  "block.minecraft.black_glazed_terracotta": "schwoaze glasierte keramik",
  "block.minecraft.white_concrete": "weißa bedau",
  "block.minecraft.orange_concrete": "oranga bedau",
  "block.minecraft.magenta_concrete": "magenta bedau",
  "block.minecraft.light_blue_concrete": "höiblaua bedau",
  "block.minecraft.yellow_concrete": "gejba bedau",
  "block.minecraft.lime_concrete": "giftgreana bedau",
  "block.minecraft.pink_concrete": "rosa bedau",
  "block.minecraft.gray_concrete": "graua bedau",
  "block.minecraft.light_gray_concrete": "höigraua bedau",
  "block.minecraft.cyan_concrete": "türkisa bedau",
  "block.minecraft.purple_concrete": "violetta bedau",
  "block.minecraft.blue_concrete": "blaua bedau",
  "block.minecraft.brown_concrete": "brauna bedau",
  "block.minecraft.green_concrete": "greana bedau",
  "block.minecraft.red_concrete": "rouda bedau",
  "block.minecraft.black_concrete": "schwoaza bedau",
  "block.minecraft.white_concrete_powder": "weißa trocknbeton",
  "block.minecraft.orange_concrete_powder": "oranga trocknbedau",
  "block.minecraft.magenta_concrete_powder": "magenta trocknbedau",
  "block.minecraft.light_blue_concrete_powder": "höiblaua trocknbedau",
  "block.minecraft.yellow_concrete_powder": "gejba trocknbedau",
  "block.minecraft.lime_concrete_powder": "giftgreana trocknbedau",
  "block.minecraft.pink_concrete_powder": "rosa trocknbedau",
  "block.minecraft.gray_concrete_powder": "graua trocknbedau",
  "block.minecraft.light_gray_concrete_powder": "höigraua trocknbedau",
  "block.minecraft.cyan_concrete_powder": "türkisa trocknbedau",
  "block.minecraft.purple_concrete_powder": "violetta trocknbedau",
  "block.minecraft.blue_concrete_powder": "blaua trocknbedau",
  "block.minecraft.brown_concrete_powder": "brauna trocknbedau",
  "block.minecraft.green_concrete_powder": "greana trocknbedau",
  "block.minecraft.red_concrete_powder": "rouda trocknbedau",
  "block.minecraft.black_concrete_powder": "schwoaza trocknbedau",
  "block.minecraft.turtle_egg": "schuidkrötnoa",
  "block.minecraft.dead_tube_coral_block": "doda orgelkorallnblock",
  "block.minecraft.dead_brain_coral_block": "doda hirnkorallnblock",
  "block.minecraft.dead_bubble_coral_block": "doda blasenkorallnblock",
  "block.minecraft.dead_fire_coral_block": "doda feierkorallnblock",
  "block.minecraft.dead_horn_coral_block": "doda hornkorallnblock",
  "block.minecraft.tube_coral_block": "orgelkorallnblock",
  "block.minecraft.brain_coral_block": "hirnkorallnblock",
  "block.minecraft.bubble_coral_block": "blasenkorallnblock",
  "block.minecraft.fire_coral_block": "feierkorallnblock",
  "block.minecraft.horn_coral_block": "hornkorallnblock",
  "block.minecraft.tube_coral": "käichkoralle",
  "block.minecraft.brain_coral": "hirnkoralle",
  "block.minecraft.bubble_coral": "blasnkoralle",
  "block.minecraft.fire_coral": "feierkoralle",
  "block.minecraft.horn_coral": "hornkoralle",
  "block.minecraft.dead_brain_coral": "doode hirnkoralle",
  "block.minecraft.dead_bubble_coral": "doode blasenkoralle",
  "block.minecraft.dead_fire_coral": "doode feierkoralle",
  "block.minecraft.dead_horn_coral": "doode hornkoralle",
  "block.minecraft.dead_tube_coral": "doode orgelkoralle",
  "block.minecraft.tube_coral_fan": "orgelkorallnfächer",
  "block.minecraft.brain_coral_fan": "hirnkorallnfächer",
  "block.minecraft.bubble_coral_fan": "blasenkorallnfächer",
  "block.minecraft.fire_coral_fan": "feierkorallnfächer",
  "block.minecraft.horn_coral_fan": "hornkorallnfächer",
  "block.minecraft.dead_tube_coral_fan": "dooda orgelkorallenfächa",
  "block.minecraft.dead_brain_coral_fan": "dooda hirnkorallnfächa",
  "block.minecraft.dead_bubble_coral_fan": "dooda blasenkorallnfächa",
  "block.minecraft.dead_fire_coral_fan": "dooda feuerkorallnfächa",
  "block.minecraft.dead_horn_coral_fan": "dooda geweihkorallnfächa",
  "block.minecraft.blue_ice": "blaueis",
  "block.minecraft.conduit": "aquisator",
  "block.minecraft.polished_granite_stairs": "polierte granitschdiang",
  "block.minecraft.smooth_red_sandstone_stairs": "glatte roude sondstoaschdiang",
  "block.minecraft.mossy_stone_brick_stairs": "bemooste stoazieglschdiang",
  "block.minecraft.polished_diorite_stairs": "polierte dioritschdiang",
  "block.minecraft.mossy_cobblestone_stairs": "bemooste bruchstoaschdiang",
  "block.minecraft.end_stone_brick_stairs": "endstoazieglschdiang",
  "block.minecraft.stone_stairs": "stoaschdiang",
  "block.minecraft.smooth_sandstone_stairs": "glatte sondstoaschdiang",
  "block.minecraft.smooth_quartz_stairs": "glatte quarzschdiang",
  "block.minecraft.granite_stairs": "granitschdiang",
  "block.minecraft.andesite_stairs": "andesitschdiang",
  "block.minecraft.red_nether_brick_stairs": "roude netherzieglschdiang",
  "block.minecraft.polished_andesite_stairs": "polierte andesitschdiang",
  "block.minecraft.diorite_stairs": "dioritschdiang",
  "block.minecraft.polished_granite_slab": "polierte granitstufe",
  "block.minecraft.smooth_red_sandstone_slab": "glatte roude sondstoastufe",
  "block.minecraft.mossy_stone_brick_slab": "bemooste stoizieglstufn",
  "block.minecraft.polished_diorite_slab": "polierte dioritstufe",
  "block.minecraft.mossy_cobblestone_slab": "bemooste bruchstoastufn",
  "block.minecraft.end_stone_brick_slab": "endstoazieglstufn",
  "block.minecraft.smooth_sandstone_slab": "glatte sondstoastufe",
  "block.minecraft.smooth_quartz_slab": "glatte quarzstufe",
  "block.minecraft.granite_slab": "granitstufe",
  "block.minecraft.andesite_slab": "andesitstufe",
  "block.minecraft.red_nether_brick_slab": "rode netherzieglschdiang",
  "block.minecraft.polished_andesite_slab": "polierte andesitstufe",
  "block.minecraft.diorite_slab": "dioritstufn",
  "block.minecraft.scaffolding": "g'rüst",
  "block.minecraft.iron_door": "eisentia",
  "block.minecraft.oak_door": "oachenhoiztia",
  "block.minecraft.spruce_door": "fichtnhoiztia",
  "block.minecraft.birch_door": "birknhoiztia",
  "block.minecraft.jungle_door": "tropnhoiztia",
  "block.minecraft.acacia_door": "akazienhoiztia",
  "block.minecraft.dark_oak_door": "schwoazoachenhoiztia",
  "block.minecraft.crimson_door": "karmesintia",
  "block.minecraft.warped_door": "wirrtia",
  "block.minecraft.repeater": "redstone verstärka",
  "block.minecraft.comparator": "redstone komparatoa",
  "block.minecraft.structure_block": "konstruktionsblock",
  "block.minecraft.jigsaw": "verbundblock",
  "item.minecraft.turtle_helmet": "schuidkrötnpanza□□af dem schädl:□+2 rüstung",
  "item.minecraft.scute": "hornschild",
  "item.minecraft.iron_shovel": "eisenschaufl□□in da haupthond:□+3.5 angriffsschadn□-3 angriffsgschwindigkeit",
  "item.minecraft.iron_pickaxe": "eisengrompm□□in da haupthond:□+3 angriffsschadn□-2.8 angriffsgschwindigkeit",
  "item.minecraft.iron_axe": "eisenhogg□□in da haupthond:□+8 angriffsschadn□-3.1 angriffsgschwindigkeit",
  "item.minecraft.flint_and_steel": "feiazeig",
  "item.minecraft.apple": "opfe",
  "item.minecraft.bow": "boong",
  "item.minecraft.arrow": "pfeil",
  "item.minecraft.coal": "kuin",
  "item.minecraft.charcoal": "hoizkuin",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "eisenbarren",
  "item.minecraft.gold_ingot": "goidbarren",
  "item.minecraft.netherite_ingot": "netheritbarren",
  "item.minecraft.netherite_scrap": "netheritbrockn",
  "item.minecraft.iron_sword": "eisenschwert□□in da haupthond:□+5 angriffsschadn□-2.4 angriffsgschwindigkeit",
  "item.minecraft.wooden_sword": "hoizschwert□□in da haupthond:□+3 angriffsschadn□-2.4 angriffsgschwindigkeit",
  "item.minecraft.wooden_shovel": "hoizschaufl□□in da haupthond:□+1.5 angriffsschadn□-3 angriffsgschwindigkeit",
  "item.minecraft.wooden_pickaxe": "hoizgrompm□□in da haupthond:□+1 angriffsschadn□-2.8 angriffsgschwindigkeit",
  "item.minecraft.wooden_axe": "hoizhogg□□in da haupthond:□+6 angriffsschadn□-3.2 angriffsgschwindigkeit",
  "item.minecraft.stone_sword": "stoaschwert□□in da haupthond:□+4 angriffsschadn□-2.4 angriffsgschwindigkeit",
  "item.minecraft.stone_shovel": "stoaschaufl□□in da haupthond:□+2.5 angriffsschadn□-3 angriffsgschwindigkeit",
  "item.minecraft.stone_pickaxe": "stoagrompm□□in da haupthond:□+2 angriffsschadn□-2.8 angriffsgschwindigkeit",
  "item.minecraft.stone_axe": "stoahogg□□in da haupthond:□+8 angriffsschadn□-3.2 angriffsgschwindigkeit",
  "item.minecraft.diamond_sword": "diamantschwert□□in da haupthond:□+6 angriffsschadn□-2.4 angriffsgschwindigkeit",
  "item.minecraft.diamond_shovel": "diamantschaufl□□in da haupthond:□+4.5 angriffsschadn□-3 angriffsgschwindigkeit",
  "item.minecraft.diamond_pickaxe": "diamantgrompm□□in da haupthond:□+4 angriffsschadn□-2.8 angriffsgschwindigkeit",
  "item.minecraft.diamond_axe": "diamanthogg□□in da haupthond:□+8 angriffsschadn□-3 angriffsgschwindigkeit",
  "item.minecraft.stick": "stock",
  "item.minecraft.bowl": "schüssl",
  "item.minecraft.mushroom_stew": "schwammal suppn",
  "item.minecraft.golden_sword": "goidschwert□□in da haupthond:□+3 angriffsschadn□-2.4 angriffsgschwindigkeit",
  "item.minecraft.golden_shovel": "goidschaufl□□in da haupthond:□+1.5 angriffsschadn□-3 angriffsgschwindigkeit",
  "item.minecraft.golden_pickaxe": "goidgrompm□□in da haupthond:□+1 angriffsschadn□-2.8 angriffsgschwindigkeit",
  "item.minecraft.golden_axe": "goidhogg□□in da haupthond:□+6 angriffsschadn□-3 angriffsgschwindigkeit",
  "item.minecraft.netherite_sword": "netheritschwert□□in da haupthond:□+7 angriffsschadn□-2.4 angriffsgschwindigkeit",
  "item.minecraft.netherite_shovel": "netheritschaufl□□in da haupthond:□+5.5 angriffsschadn□-3 angriffsgschwindigkeit",
  "item.minecraft.netherite_pickaxe": "netheritgrompm□□in da haupthond:□+5 angriffsschadn□-2.8 angriffsgschwindigkeit",
  "item.minecraft.netherite_axe": "netherithogg□□in da haupthond:□+9 angriffsschadn□-3 angriffsgschwindigkeit",
  "item.minecraft.string": "fadn",
  "item.minecraft.feather": "feda",
  "item.minecraft.gunpowder": "schwoazpulva",
  "item.minecraft.wooden_hoe": "hoizhau□□in da haupthond:□-3 angriffsgschwindigkeit",
  "item.minecraft.stone_hoe": "stoahau□□in da haupthond:□-2 angriffsgschwindigkeit",
  "item.minecraft.iron_hoe": "eisenhau□□in da haupthond:□-1 angriffsgschwindigkeit",
  "item.minecraft.diamond_hoe": "diamanthau□□in da haupthond:",
  "item.minecraft.golden_hoe": "goidhau□□in da haupthond:□-3 angriffsgschwindigkeit",
  "item.minecraft.netherite_hoe": "netherithakn□□in da haupthond:",
  "item.minecraft.wheat_seeds": "woaznkerndl",
  "item.minecraft.wheat": "woazn",
  "item.minecraft.bread": "brod",
  "item.minecraft.leather_helmet": "ledermützn□□af dem schädl:□+1 rüstung",
  "item.minecraft.leather_chestplate": "ledajanka□□am kerpr:□+3 rüstung",
  "item.minecraft.leather_leggings": "ledahosn□□an den haxn:□+2 rüstung",
  "item.minecraft.leather_boots": "lederschuah□□an den fiaßn:□+1 rüstung",
  "item.minecraft.chainmail_helmet": "kettenmützn□□af dem schädl:□+2 rüstung",
  "item.minecraft.chainmail_chestplate": "kettnhemat□□am kerpr:□+5 rüstung",
  "item.minecraft.chainmail_leggings": "kettnhosn□□an den haxn:□+4 rüstung",
  "item.minecraft.chainmail_boots": "kettnsocka□□an den fiaßn:□+1 rüstung",
  "item.minecraft.iron_helmet": "eisenhelm□□af dem schädl:□+2 rüstung",
  "item.minecraft.iron_chestplate": "eisenharnisch□□am kerpr:□+6 rüstung",
  "item.minecraft.iron_leggings": "eisenhaxnschutz□□an den haxn:□+5 rüstung",
  "item.minecraft.iron_boots": "eisenschuah□□an den fiaßn:□+2 rüstung",
  "item.minecraft.diamond_helmet": "diamanthelm□□af dem schädl:□+3 rüstung□+2 rüstungshärtn",
  "item.minecraft.diamond_chestplate": "diamantharnisch□□am kerpr:□+8 rüstung□+2 rüstungshärtn",
  "item.minecraft.diamond_leggings": "diamanthaxnschutz□□an den haxn:□+6 rüstung□+2 rüstungshärtn",
  "item.minecraft.diamond_boots": "diamantschuah□□an den fiaßn:□+3 rüstung□+2 rüstungshärtn",
  "item.minecraft.golden_helmet": "goidhelm□□af dem schädl:□+2 rüstung",
  "item.minecraft.golden_chestplate": "goidharnisch□□am kerpr:□+5 rüstung",
  "item.minecraft.golden_leggings": "goidhaxnschutz□□an den haxn:□+3 rüstung",
  "item.minecraft.golden_boots": "goidschuah□□an den fiaßn:□+1 rüstung",
  "item.minecraft.netherite_helmet": "netherithelm□□af dem schädl:□+3 rüstung□+3 rüstungshärtn□+1 stondfestigkeit",
  "item.minecraft.netherite_chestplate": "netheritbrustplattn□□am kerpr:□+8 rüstung□+3 rüstungshärtn□+1 stondfestigkeit",
  "item.minecraft.netherite_leggings": "netherithaxnschutz□□an den haxn:□+6 rüstung□+3 rüstungshärtn□+1 stondfestigkeit",
  "item.minecraft.netherite_boots": "netheritschuah□□an den fiaßn:□+3 rüstung□+3 rüstungshärtn□+1 stondfestigkeit",
  "item.minecraft.flint": "feiastoa",
  "item.minecraft.porkchop": "rohs schweiners",
  "item.minecraft.cooked_porkchop": "schweinsbratn",
  "item.minecraft.painting": "gemälde",
  "item.minecraft.golden_apple": "goidener opfe",
  "item.minecraft.enchanted_golden_apple": "verzauberter goidener opfe",
  "block.minecraft.oak_sign": "oachenhoizschuid",
  "block.minecraft.spruce_sign": "fichtnhoizschuid",
  "block.minecraft.birch_sign": "birknhoizschuid",
  "block.minecraft.jungle_sign": "tropnhoizschuidl",
  "block.minecraft.acacia_sign": "akazienhoizschuid",
  "block.minecraft.dark_oak_sign": "schwoazoachenschuid",
  "block.minecraft.crimson_sign": "karmesinschuid",
  "block.minecraft.warped_sign": "wirrschuid",
  "item.minecraft.bucket": "oama",
  "item.minecraft.water_bucket": "wossaoima",
  "item.minecraft.lava_bucket": "lavaoima",
  "item.minecraft.minecart": "lore",
  "item.minecraft.saddle": "sattel",
  "item.minecraft.redstone": "redstone-waugerln",
  "item.minecraft.snowball": "schnääboi",
  "item.minecraft.oak_boat": "oachenhoizboot",
  "item.minecraft.leather": "leda",
  "item.minecraft.milk_bucket": "muichoima",
  "item.minecraft.pufferfish_bucket": "kuglfiischoima",
  "item.minecraft.salmon_bucket": "oima volla lachs",
  "item.minecraft.cod_bucket": "kabeljauoima",
  "item.minecraft.tropical_fish_bucket": "tropnfiischoima",
  "item.minecraft.brick": "ziegl",
  "item.minecraft.clay_ball": "tonklumpn",
  "block.minecraft.dried_kelp_block": "getrockneta seetangblock",
  "item.minecraft.paper": "papier",
  "item.minecraft.book": "buach",
  "item.minecraft.slime_ball": "schleimboi",
  "item.minecraft.chest_minecart": "gütalore",
  "item.minecraft.furnace_minecart": "ontriebslore",
  "item.minecraft.egg": "oa",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "angel",
  "item.minecraft.clock": "uah",
  "item.minecraft.glowstone_dust": "glowstonewaugerln",
  "item.minecraft.cod": "rohs kabeljau",
  "item.minecraft.salmon": "rohs lachs",
  "item.minecraft.tropical_fish": "tropnfiisch",
  "item.minecraft.pufferfish": "kuglfiisch",
  "item.minecraft.cooked_cod": "gebranter kabeljau",
  "item.minecraft.cooked_salmon": "gebranter lachs",
  "item.minecraft.ink_sac": "tintnbeitl",
  "item.minecraft.red_dye": "rouda foabstoff",
  "item.minecraft.green_dye": "greana foabstoff",
  "item.minecraft.cocoa_beans": "kakaobohna",
  "item.minecraft.lapis_lazuli": "lapislazuli",
  "item.minecraft.purple_dye": "violetta foabstoff",
  "item.minecraft.cyan_dye": "türkisa foabstoff",
  "item.minecraft.light_gray_dye": "höigraue farb",
  "item.minecraft.gray_dye": "graua foabstoff",
  "item.minecraft.pink_dye": "rosa foabstoff",
  "item.minecraft.lime_dye": "giftgreana foabstoff",
  "item.minecraft.yellow_dye": "gejba foabstoff",
  "item.minecraft.light_blue_dye": "höiblaue farb",
  "item.minecraft.magenta_dye": "magenta farb",
  "item.minecraft.orange_dye": "oranga foabstoff",
  "item.minecraft.bone_meal": "boanenmej",
  "item.minecraft.blue_dye": "blaua foabstoff",
  "item.minecraft.brown_dye": "brauna foabstoff",
  "item.minecraft.black_dye": "schwoaza foabstoff",
  "item.minecraft.white_dye": "weißa foabstoff",
  "item.minecraft.bone": "boanen",
  "item.minecraft.sugar": "zugga",
  "block.minecraft.cake": "kuacha",
  "block.minecraft.white_bed": "weißes bett",
  "block.minecraft.orange_bed": "oranges bett",
  "block.minecraft.magenta_bed": "magenta bett",
  "block.minecraft.light_blue_bed": "höiblaues bett",
  "block.minecraft.yellow_bed": "geibs bett",
  "block.minecraft.lime_bed": "giftgreans bett",
  "block.minecraft.pink_bed": "rosa bett",
  "block.minecraft.gray_bed": "graus bett",
  "block.minecraft.light_gray_bed": "höigraues bett",
  "block.minecraft.cyan_bed": "türkis' bett",
  "block.minecraft.purple_bed": "lila bett",
  "block.minecraft.blue_bed": "blaus bett",
  "block.minecraft.brown_bed": "brauns bett",
  "block.minecraft.green_bed": "greans bett",
  "block.minecraft.red_bed": "rouds bett",
  "block.minecraft.black_bed": "schwoazs bett",
  "item.minecraft.cookie": "keks",
  "item.minecraft.filled_map": "koate□#0",
  "item.minecraft.shears": "rebschaa",
  "item.minecraft.melon_slice": "stickl melona",
  "item.minecraft.dried_kelp": "getrockneter seetang",
  "item.minecraft.pumpkin_seeds": "kürbiskerndl",
  "item.minecraft.melon_seeds": "melonakerndl",
  "item.minecraft.beef": "rohs rind",
  "item.minecraft.cooked_beef": "steak",
  "item.minecraft.chicken": "rohs händl",
  "item.minecraft.cooked_chicken": "brathändl",
  "item.minecraft.rotten_flesh": "verrottetes fleisch",
  "item.minecraft.ender_pearl": "enderperle",
  "item.minecraft.blaze_rod": "lohenrute",
  "item.minecraft.ghast_tear": "ghastträne",
  "item.minecraft.gold_nugget": "goidklumpn",
  "item.minecraft.nether_wart": "netherwarzn",
  "item.minecraft.potion": "nicht braubara trank□wirkungslos",
  "item.minecraft.glass_bottle": "artikel.minecraft.glasflasche",
  "item.minecraft.spider_eye": "spinnaaug",
  "item.minecraft.fermented_spider_eye": "fermentiertes spinnaauge",
  "item.minecraft.blaze_powder": "artikel.minecraft.flammenpuder",
  "item.minecraft.magma_cream": "magmacreme",
  "block.minecraft.brewing_stand": "braustand",
  "block.minecraft.cauldron": "kessl",
  "item.minecraft.ender_eye": "enderaug",
  "item.minecraft.glistering_melon_slice": "glitzande melonenscheibe",
  "item.minecraft.bat_spawn_egg": "fledermaus-spawn-oa",
  "item.minecraft.bee_spawn_egg": "impn-spawn-oa",
  "item.minecraft.blaze_spawn_egg": "lohe-spawn-oa",
  "item.minecraft.cat_spawn_egg": "kotz-spawn-oa",
  "item.minecraft.cave_spider_spawn_egg": "höin spinna-spawn-oa",
  "item.minecraft.chicken_spawn_egg": "huhn-spawn-oa",
  "item.minecraft.cod_spawn_egg": "kabeljau-spawn-oa",
  "item.minecraft.cow_spawn_egg": "rindvieh-spawn-oa",
  "item.minecraft.creeper_spawn_egg": "creeper-spawn-oa",
  "item.minecraft.dolphin_spawn_egg": "delfin-spawn-oa",
  "item.minecraft.donkey_spawn_egg": "esel-spawn-oa",
  "item.minecraft.drowned_spawn_egg": "ertrunkener-spawn-oa",
  "item.minecraft.elder_guardian_spawn_egg": "großer wächter-spawn-oa",
  "item.minecraft.enderman_spawn_egg": "enderman-spawn-oa",
  "item.minecraft.endermite_spawn_egg": "endermite-spawn-oa",
  "item.minecraft.evoker_spawn_egg": "magier-spawn-oa",
  "item.minecraft.fox_spawn_egg": "fuchs-spawn-oa",
  "item.minecraft.ghast_spawn_egg": "ghast-spawn-oa",
  "item.minecraft.guardian_spawn_egg": "wächter-spawn-oa",
  "item.minecraft.hoglin_spawn_egg": "hoglin-spawn-oa",
  "item.minecraft.horse_spawn_egg": "roß-spawn-oa",
  "item.minecraft.husk_spawn_egg": "wiastnzombie-spawn-oa",
  "item.minecraft.llama_spawn_egg": "lama-spawn-oa",
  "item.minecraft.magma_cube_spawn_egg": "magmawürfel-spawn-oa",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom-spawn-oa",
  "item.minecraft.mule_spawn_egg": "maultier-spawn-oa",
  "item.minecraft.ocelot_spawn_egg": "wuidkotz-spawn-oa",
  "item.minecraft.panda_spawn_egg": "panda-spawn-oa",
  "item.minecraft.parrot_spawn_egg": "papagei-spawn-oa",
  "item.minecraft.phantom_spawn_egg": "phantom-spawn-oa",
  "item.minecraft.pig_spawn_egg": "sei-spawn-oa",
  "item.minecraft.piglin_spawn_egg": "piglin-spawn-oa",
  "item.minecraft.pillager_spawn_egg": "plünderer-spawn-oa",
  "item.minecraft.polar_bear_spawn_egg": "eisbär-spawn-oa",
  "item.minecraft.pufferfish_spawn_egg": "kuglfisch-spawn-oa",
  "item.minecraft.rabbit_spawn_egg": "hasn-spawn-oa",
  "item.minecraft.ravager_spawn_egg": "verwüsta-spawn-oa",
  "item.minecraft.salmon_spawn_egg": "lachs-spawn-oa",
  "item.minecraft.sheep_spawn_egg": "schof-spawn-oa",
  "item.minecraft.shulker_spawn_egg": "shulker-spawn-oa",
  "item.minecraft.silverfish_spawn_egg": "silberfisch-spawn-oa",
  "item.minecraft.skeleton_spawn_egg": "skelett-spawn-oa",
  "item.minecraft.skeleton_horse_spawn_egg": "skelettpferdl-spawn-oa",
  "item.minecraft.slime_spawn_egg": "schleim-spawn-oa",
  "item.minecraft.spider_spawn_egg": "spinna-spawn-oa",
  "item.minecraft.squid_spawn_egg": "tintnfisch-spawn-oa",
  "item.minecraft.stray_spawn_egg": "eiswondera-spawn-oa",
  "item.minecraft.strider_spawn_egg": "schreita-spawn-oa",
  "item.minecraft.trader_llama_spawn_egg": "händlalama-spawn-oa",
  "item.minecraft.tropical_fish_spawn_egg": "tropischa fiisch-spawn-oa",
  "item.minecraft.turtle_spawn_egg": "schuidkrötn-spawn-oa",
  "item.minecraft.vex_spawn_egg": "poitergeist-spawn-oa",
  "item.minecraft.villager_spawn_egg": "dorfbewohna-spawn-oa",
  "item.minecraft.vindicator_spawn_egg": "maulaff-spawn-oa",
  "item.minecraft.wandering_trader_spawn_egg": "dandler-spawn-oa",
  "item.minecraft.witch_spawn_egg": "hexn-spawn-oa",
  "item.minecraft.wither_skeleton_spawn_egg": "witherskelett-spawn-oa",
  "item.minecraft.wolf_spawn_egg": "woifs-spawn-oa",
  "item.minecraft.zoglin_spawn_egg": "zoglin-spawn-oa",
  "item.minecraft.zombie_spawn_egg": "zombie-spawn-oa",
  "item.minecraft.zombie_horse_spawn_egg": "zombiepferdl-spawn-oa",
  "item.minecraft.zombie_villager_spawn_egg": "zombiedorfmensch-spawn-oa",
  "item.minecraft.zombified_piglin_spawn_egg": "zombifizierter-piglin-spawn-oa",
  "item.minecraft.experience_bottle": "zauberflaschl",
  "item.minecraft.fire_charge": "feierboi",
  "item.minecraft.writable_book": "buach und feda",
  "item.minecraft.written_book": "voigschrims buach",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "rahm’",
  "block.minecraft.flower_pot": "bleamentopf",
  "item.minecraft.carrot": "gejbe ruam",
  "item.minecraft.potato": "eadopfe",
  "item.minecraft.baked_potato": "backne kadoffe",
  "item.minecraft.poisonous_potato": "giftige kadoffe",
  "item.minecraft.map": "leere koate",
  "item.minecraft.golden_carrot": "goidene ruam",
  "block.minecraft.skeleton_skull": "skelettschädl",
  "block.minecraft.wither_skeleton_skull": "witherskelettschädl",
  "block.minecraft.player_head": "spielaschädl",
  "block.minecraft.zombie_head": "zombieschädl",
  "block.minecraft.creeper_head": "creeperschädl",
  "block.minecraft.dragon_head": "drachnschädl",
  "item.minecraft.carrot_on_a_stick": "karottn om stock",
  "item.minecraft.warped_fungus_on_a_stick": "wirrschwammalrute",
  "item.minecraft.nether_star": "netherstern",
  "item.minecraft.pumpkin_pie": "kürbiskuacha",
  "item.minecraft.firework_rocket": "feierwerksraketn",
  "item.minecraft.firework_star": "feierwerksstern",
  "item.minecraft.enchanted_book": "zaubabuach",
  "item.minecraft.nether_brick": "netherziegl",
  "item.minecraft.quartz": "netherquarz",
  "item.minecraft.tnt_minecart": "tnt-lore",
  "item.minecraft.hopper_minecart": "trichtalore",
  "item.minecraft.prismarine_shard": "prismarinscherbe",
  "item.minecraft.prismarine_crystals": "prismarinkristalle",
  "item.minecraft.rabbit": "rohs haas",
  "item.minecraft.cooked_rabbit": "bratner haas",
  "item.minecraft.rabbit_stew": "haasnsuppn",
  "item.minecraft.rabbit_foot": "hasenfuaß",
  "item.minecraft.rabbit_hide": "hasenfell",
  "item.minecraft.armor_stand": "rüstungsstända",
  "item.minecraft.iron_horse_armor": "eiserna roßharnisch",
  "item.minecraft.golden_horse_armor": "goidena roßharnisch",
  "item.minecraft.diamond_horse_armor": "diamantena roßharnisch",
  "item.minecraft.leather_horse_armor": "ledana roßharnisch",
  "item.minecraft.lead": "leine",
  "item.minecraft.name_tag": "namansschuid",
  "item.minecraft.command_block_minecart": "befehlsblocklore",
  "item.minecraft.mutton": "rohs lamm",
  "item.minecraft.cooked_mutton": "lammkoteletts",
  "block.minecraft.white_banner": "weissa banner",
  "block.minecraft.orange_banner": "orangschener banner",
  "block.minecraft.magenta_banner": "magenta banner",
  "block.minecraft.light_blue_banner": "höiblaua banner",
  "block.minecraft.yellow_banner": "gelba banner",
  "block.minecraft.lime_banner": "giftgreana banner",
  "block.minecraft.pink_banner": "rosa banner",
  "block.minecraft.gray_banner": "graus banner",
  "block.minecraft.light_gray_banner": "höigraua banner",
  "block.minecraft.cyan_banner": "türkisa banner",
  "block.minecraft.purple_banner": "lila banner",
  "block.minecraft.blue_banner": "blaua banner",
  "block.minecraft.brown_banner": "brauna banner",
  "block.minecraft.green_banner": "greana banner",
  "block.minecraft.red_banner": "rouda banner",
  "block.minecraft.black_banner": "schwoaza banner",
  "item.minecraft.end_crystal": "enderkrisdoj",
  "item.minecraft.chorus_fruit": "chorusfrucht",
  "item.minecraft.popped_chorus_fruit": "springende chorus-frucht",
  "item.minecraft.beetroot": "ranna",
  "item.minecraft.beetroot_seeds": "rannakerndl",
  "item.minecraft.beetroot_soup": "borschtsch",
  "item.minecraft.dragon_breath": "drachnatem",
  "item.minecraft.splash_potion": "nicht braubara wurftrank□wirkungslos",
  "item.minecraft.spectral_arrow": "spektralpfeil",
  "item.minecraft.tipped_arrow": "nicht herstellbara getränkta pfeil□wirkungslos",
  "item.minecraft.lingering_potion": "nicht braubara verweiltrank□wirkungslos",
  "item.minecraft.shield": "schuidl",
  "item.minecraft.elytra": "elytren",
  "item.minecraft.spruce_boat": "fichtnhoizboot",
  "item.minecraft.birch_boat": "birknhoizboot",
  "item.minecraft.jungle_boat": "tropnhoizboot",
  "item.minecraft.acacia_boat": "akazienhoizboot",
  "item.minecraft.dark_oak_boat": "schwoazoachenhoizboot",
  "item.minecraft.totem_of_undying": "totem da unsterblichkeit",
  "item.minecraft.shulker_shell": "shulker-schale",
  "item.minecraft.iron_nugget": "eisenklumpn",
  "item.minecraft.knowledge_book": "buach des wissens",
  "item.minecraft.debug_stick": "debug-stock",
  "item.minecraft.music_disc_13": "schoiplattn□c418 - 13",
  "item.minecraft.music_disc_cat": "schoiplattn□c418 - cat",
  "item.minecraft.music_disc_blocks": "schoiplattn□c418 - blocks",
  "item.minecraft.music_disc_chirp": "schoiplattn□c418 - chirp",
  "item.minecraft.music_disc_far": "schoiplattn□c418 - far",
  "item.minecraft.music_disc_mall": "schoiplattn□c418 - mall",
  "item.minecraft.music_disc_mellohi": "schoiplattn□c418 - mellohi",
  "item.minecraft.music_disc_stal": "schoiplattn□c418 - stal",
  "item.minecraft.music_disc_strad": "schoiplattn□c418 - strad",
  "item.minecraft.music_disc_ward": "schoiplattn□c418 - ward",
  "item.minecraft.music_disc_11": "schoiplattn□c418 - 11",
  "item.minecraft.music_disc_wait": "schoiplattn□c418 - wait",
  "item.minecraft.music_disc_pigstep": "schoiplattn□lena raine ‐ pigstep",
  "item.minecraft.trident": "dreizack□□in da haupthond:□+8 angriffsschadn□-2.9 angriffsgschwindigkeit",
  "item.minecraft.phantom_membrane": "phantommembran",
  "item.minecraft.nautilus_shell": "schnecknheiserl",
  "item.minecraft.heart_of_the_sea": "meerherz",
  "item.minecraft.crossbow": "oambrust",
  "item.minecraft.suspicious_stew": "komische suppn",
  "block.minecraft.loom": "webstui",
  "item.minecraft.flower_banner_pattern": "bannervorlage□bläamen",
  "item.minecraft.creeper_banner_pattern": "bannervorlage□creeper",
  "item.minecraft.skull_banner_pattern": "bannervorlage□schädl",
  "item.minecraft.mojang_banner_pattern": "bannervorlage□mojang-logo",
  "item.minecraft.globe_banner_pattern": "bannervorlagn□globus",
  "item.minecraft.piglin_banner_pattern": "bannervorlage□schnauze",
  "block.minecraft.composter": "kompostiaanlag",
  "block.minecraft.barrel": "fassl",
  "block.minecraft.smoker": "reichaofn",
  "block.minecraft.blast_furnace": "schmöizofn",
  "block.minecraft.cartography_table": "koatndisch",
  "block.minecraft.fletching_table": "bognadisch",
  "block.minecraft.grindstone": "schleifstoa",
  "block.minecraft.lectern": "lesepuit",
  "block.minecraft.smithing_table": "schmieddisch",
  "block.minecraft.stonecutter": "stoametz",
  "block.minecraft.bell": "glocke",
  "block.minecraft.lantern": "laterne",
  "block.minecraft.soul_lantern": "seelenlaterne",
  "item.minecraft.sweet_berries": "siaßbean",
  "block.minecraft.campfire": "lagafeia",
  "block.minecraft.soul_campfire": "seelenlagafeia",
  "block.minecraft.shroomlight": "schwammalliacht",
  "item.minecraft.honeycomb": "honiwabe",
  "block.minecraft.bee_nest": "impnnest",
  "block.minecraft.beehive": "impnstock",
  "item.minecraft.honey_bottle": "honiflasche",
  "block.minecraft.honey_block": "honiblock",
  "block.minecraft.honeycomb_block": "honiwabnblock",
  "block.minecraft.lodestone": "leitstoa",
  "block.minecraft.netherite_block": "netheritblock",
  "block.minecraft.ancient_debris": "antiker schutt",
  "block.minecraft.target": "zuiblock",
  "block.minecraft.crying_obsidian": "weinenda obsidian",
  "block.minecraft.blackstone": "schwoazstoa",
  "block.minecraft.blackstone_slab": "schwoazstoastufe",
  "block.minecraft.blackstone_stairs": "schwoazstoaschdiang",
  "block.minecraft.gilded_blackstone": "goidduachzogena schwoazstoa",
  "block.minecraft.polished_blackstone": "polierta schwoazstoa",
  "block.minecraft.polished_blackstone_slab": "polierte schwoazstoastufe",
  "block.minecraft.polished_blackstone_stairs": "polierte schwoazstoaschdiang",
  "block.minecraft.chiseled_polished_blackstone": "gemeißelta polierta schwoazstoa",
  "block.minecraft.polished_blackstone_bricks": "polierte schwoazstoaziegl",
  "block.minecraft.polished_blackstone_brick_slab": "polierte schwoazstoazieglstufe",
  "block.minecraft.polished_blackstone_brick_stairs": "polierte schwoazstoazieglschdiang",
  "block.minecraft.cracked_polished_blackstone_bricks": "rissige polierte schwoazstoaziegl",
  "block.minecraft.respawn_anchor": "seelenanka",
}
export const bar = items; 
